/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ProfileAccountDetails_user = {
    readonly id: string;
    readonly profile: {
        readonly id: string;
        readonly name: string;
        readonly surname: string;
        readonly company: string;
        readonly email: string;
        readonly contactNumber: string;
        readonly profileImageURL: string;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"ProfileEditDetails_user">;
    readonly " $refType": "ProfileAccountDetails_user";
};
export type ProfileAccountDetails_user$data = ProfileAccountDetails_user;
export type ProfileAccountDetails_user$key = {
    readonly " $data"?: ProfileAccountDetails_user$data;
    readonly " $fragmentRefs": FragmentRefs<"ProfileAccountDetails_user">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileAccountDetails_user",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "UserProfile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "surname",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "company",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "contactNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "profileImageURL",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProfileEditDetails_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();
(node as any).hash = '78cea6c03074dc1d5860d4fdce5aa78d';
export default node;
